import Logo from "../../../ui/Logo/Logo";
import NavigationItem from "../NavigationItem/NavigationItem";
import urls from "../../../routes";
import User from "../User/User";
import UsageSummary from "../UsageSummary/UsageSummary";
import styles from "./Navigation.module.css";
import {
  Asterisk,
  SolidChat,
  SolidCog,
  SolidFlash,
  SolidSend,
  SolidStars,
} from "../../../ui/Icon/Icon";
import { Link } from "react-router-dom";
import GetStarted from "../GettingStarted/GetStarted";
import useUser from "../../../providers/UserProvider/useUser";
import useFeatureFlag from "../../../providers/FeatureFlagProvider/useFeatureFlag";

function Navigation() {
  const { tenant, user } = useUser();
  const { featureFlags } = useFeatureFlag();

  return (
    <div className={styles.container}>
      <Link to={urls.home} className={styles.logo}>
        <Logo />
      </Link>
      <nav className={styles.menu}>
        <ul className={styles.list}>
          <NavigationItem
            href={urls.articles}
            title="Articles"
            IconComponent={SolidFlash}
          />
          <NavigationItem
            href={urls.patterns}
            title="Patterns"
            IconComponent={SolidStars}
          />
          <NavigationItem
            href={urls.keywords.root}
            title="Keywords"
            IconComponent={Asterisk}
          />

          {/* <NavigationItem href={urls.lists} title="Lists" iconName="table" /> */}
          <NavigationItem
            href={urls.publishing.root}
            IconComponent={SolidSend}
            title="Publishing"
          />
          <NavigationItem
            className={styles.bottomSection}
            href={urls.settings.root}
            IconComponent={SolidCog}
            title="Settings"
          />
          <NavigationItem
            IconComponent={SolidChat}
            title="Support"
            onClick={() => window.Intercom("showNewMessage")}
          />
        </ul>
      </nav>

      {featureFlags.checklist && tenant && user?.email && (
        <GetStarted userId={tenant.id} emailId={user.email} />
      )}

      <UsageSummary />
      <div className={styles.bottom}>
        <User />
      </div>
    </div>
  );
}

export default Navigation;
